'use client'

import Link from 'next/link'
import { UserIcon } from '@phosphor-icons/react'
import { usePeopleNudges } from './select-people-nudges'
import { CONTACT_FREQUENCY_OPTIONS } from '@/entries'
import { TEXT_STYLES } from '@/ui/design-tokens'
import { cn } from '@/lib/tailwind'

/**
 * Shows people who are overdue for contact based on their
 * contactFrequency setting and last interaction date.
 */
export function PeopleNudges() {
  const { overdueContacts, isEmpty } = usePeopleNudges()

  if (isEmpty) {
    return (
      <div>
        <h3 className={`${TEXT_STYLES.sectionHeader} mb-2 px-2`}>People</h3>
        <p className="text-muted-foreground px-2 text-sm">
          No overdue contacts
        </p>
      </div>
    )
  }

  return (
    <div data-testid="people-nudges">
      <h3 className={`${TEXT_STYLES.sectionHeader} mb-2 px-2`}>People</h3>
      <div className="space-y-2">
        {overdueContacts.map(({ person, daysSince, frequency }) => {
          const option = CONTACT_FREQUENCY_OPTIONS.find(
            (o) => o.value === frequency,
          )
          return (
            <div key={person.id} className="flex items-center gap-2 px-2 py-1">
              <Link
                href={`/app/people?id=${person.id}`}
                className="focus-visible:ring-ring flex min-w-0 flex-1 items-center gap-2 transition-colors hover:opacity-80 focus-visible:ring-2 focus-visible:outline-none"
              >
                <UserIcon
                  className="text-muted-foreground h-3.5 w-3.5 shrink-0"
                  weight="duotone"
                />
                <span className="min-w-0 truncate text-sm font-medium">
                  {person.title}
                </span>
              </Link>
              <div className="flex shrink-0 items-center gap-2">
                {option && (
                  <span className="text-muted-foreground/60 text-xs">
                    {option.label}
                  </span>
                )}
                <span
                  className={cn('text-xs tabular-nums', 'text-destructive/70')}
                >
                  {daysSince}d ago
                </span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
